module.exports = __webpack_public_path__ + "static/img/04.c82e4b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/04.jpg
// module id = 1Fwn
// module chunks = 0